export const timePassed = (date: Date): boolean => date.getTime() < Date.now();

export const addSeconds = (date: Date, seconds: number): Date =>
  new Date(date.getTime() + seconds * 1000);
